
import { defineComponent, reactive, toRefs, PropType, watch, computed } from 'vue'
import moment, { MomentInput } from 'moment'
import 'moment-timezone'
import Datepicker from 'vue3-datepicker/src/datepicker/Datepicker.vue'
import { RESOLUTIONS } from './CameraResolutionSelector.vue'
import { ja } from 'date-fns/locale'

moment.tz.setDefault('Asia/Tokyo')

type StateTypes = {
  minute: number
  hour: number
  targetDate: Date
  minimumView: 'minute' | 'day' | 'month' | 'year'
  inputFormat: string
}

export default defineComponent({
  props: {
    resolution: {
      type: String,
      default: RESOLUTIONS.MINUTE,
    },
    modelValue: {
      type: Date as PropType<Date>,
      default: () => get_target_time(),
    },
  },
  components: {
    Datepicker,
  },
  setup(props, { emit }) {
    const state = reactive<StateTypes>({
      minute: props.modelValue.getMinutes() - (props.modelValue.getMinutes() % 5),
      hour: props.modelValue.getHours(),
      targetDate: props.modelValue,
      minimumView: 'minute',
      inputFormat: 'yyyy年MM月dd日',
    })

    const currentDatetime = computed(() => {
      const { minute, hour, targetDate } = state

      return moment(targetDate as MomentInput)
        .minute(minute)
        .hour(hour)
        .toDate()
    })

    watch(
      () => moment(currentDatetime.value).format('YYYYMMDDHHmm'),
      () => {
        emit('update:modelValue', currentDatetime.value)
      }
    )

    watch(
      () => props.modelValue,
      () => {
        state.minute = props.modelValue.getMinutes()
        state.hour = props.modelValue.getHours()
        state.targetDate = props.modelValue
      }
    )

    return {
      ...toRefs(state),
      ja,
      currentDatetime,
    }
  },
})

// 基準とする時間を返す
function get_target_time(datetime = '') {
  var time = moment()
  if (datetime) {
    time = moment(datetime, 'YYYY-MM-DD-HHmm')
  }
  var minus_min = time.minutes() % 5
  return time.add(-minus_min, 'minute')
}
